/// <reference types="knockout"/>
/// <reference path="../helpers/DateParts.ts" />
/// <reference path="../../misc/fn.ts" />
class AllWebinarsViewModel {
    constructor(model) {
        this.Webinars = WebinarViewModel.createFromArray(model.Webinars);
        this.SelectedCategory = ko.observable(null);
        this.Categories = this.getCategories();
        this.VisibleWebinars = ko.computed(this.getVisibleWebinars, this);
    }
    getCategories() {
        return ko.utils.arrayGetDistinctValues(this.Webinars.map(x => x.Category));
    }
    getVisibleWebinars() {
        return this.SelectedCategory() == null
            ? this.Webinars
            : this.Webinars.filter(x => x.Category === this.SelectedCategory());
    }
}
class WebinarViewModel {
    constructor(model) {
        ko.mapping.fromJS(model, {
            observe: [''],
            ignore: ['Times']
        }, this);
        this.LoadIframe = ko.observable(false);
        this.Dates = WebinarDateViewModel.createFromArray(model.Times);
        this.InProgress = ko.observable(null);
        ko.utils.arrayForEach(this.Dates, d => {
            this.InProgress(ko.utils.arrayFirst(d.Times, t => new Date() > t.Date.getDate() && new Date().getTime() - t.Date.getDate().getTime() < (1000 * 60 * 60)));
        });
    }
    static createFromArray(models) {
        return ko.utils.arrayMap(models, m => new WebinarViewModel(m));
    }
    getDurationDisplay() {
        var isPlural = this.Duration == 1;
        return '{0} hour{1}'.format(this.Duration, isPlural ? '' : 's');
    }
    getVideoPlayer() {
        return '<iframe type = "text/html" src="https://www.youtube.com/embed/' +
            this.VideoUrl +
            '?enablejsapi=1&modestbranding=1&showinfo=0&rel=0" frameborder= "0" allowfullscreen height="405" width="720" id="iframe-' + this.VideoUrl + '" onload="youTubeIntegration.trackVideo(this.id)"></iframe>';
    }
    getDateBlockMinHeight() {
        var numTimesPerDate = ko.utils.arrayMap(this.Dates, d => d.Times.length);
        var maxNumOfTimesInADay = Math.max.apply(null, numTimesPerDate);
        var baseHeight = 50;
        var factor = 50;
        var height = baseHeight + (factor * maxNumOfTimesInADay);
        return '{0}px'.format(height);
    }
}
class WebinarDateViewModel {
    constructor(Date, Times) {
        this.Date = Date;
        this.Times = Times;
    }
    static createFromArray(models) {
        var times = WebinarTimeViewModel.createFromArray(models);
        var groupedTimes = this.groupByDate(times);
        var dates = new Array();
        for (var timestamp in groupedTimes) {
            var date = DateParts.CreateFromTimestamp(timestamp);
            var myTimes = groupedTimes[timestamp];
            dates.push(new WebinarDateViewModel(date, myTimes));
        }
        return dates;
    }
}
WebinarDateViewModel.groupByDate = fn.groupBy((time) => time.Date.getDateWithoutTime().getTime());
class WebinarTimeViewModel {
    constructor(model) {
        ko.mapping.fromJS(model, {
            observe: [''],
            ignore: ['Date']
        }, this);
        this.Date = DateParts.CreateFromTimestamp(model.Date.TimeStamp);
    }
    static createFromArray(models) {
        return ko.utils.arrayMap(models, model => new WebinarTimeViewModel(model));
    }
}
function videoAudit() {
    var self = this;
    //console.log(routes);
    $.ajax({
        type: 'POST',
        url: webinarRoutes,
        data: {
            templateId: self.Id
        }
    });
}
;
//# sourceMappingURL=Webinars.js.map